import script from "./MainView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainView.vue?vue&type=script&setup=true&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=1ffc26fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ffc26fe"]])

export default __exports__